import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'

// Локализация
const messages = {
  ru: require('./locales/ru.json'),
  en: require('./locales/en.json')
}

const i18n = createI18n({
  legacy: false, // Важно для Vue 3 Composition API
  locale: 'ru',
  fallbackLocale: 'ru',
  messages
})

const app = createApp(App)
app.use(i18n)
app.mount('#app')

// new Vue({
//   i18n,
//   render: h => h(App)
// }).$mount('#app')